import React from 'react';
import {useSearchParams} from 'react-router-dom';

import {NAVIGATIONS} from '../Page.Projects.Update';

interface ISidebarLeftProps {}

const SidebarLeft = ({}: ISidebarLeftProps) => {
  const [searchParams] = useSearchParams();
  const nav = searchParams.get('nav');
  return (
    <section className="w-70 shrink-0 overflow-y-auto border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-darkBg p-2 lg:p-3">
      {(() => {
        const Component = nav ? NAVIGATIONS[nav as keyof typeof NAVIGATIONS]?.compLeft : Object.values(NAVIGATIONS)[0].compLeft;
        return Component ? <Component /> : null;
      })()}
    </section>
  );
};

export default React.memo(SidebarLeft);
